export default {
  APP_SET_NAV_PANEL_OPEN: 'APP_SET_NAV_PANEL_OPEN',
  _RESET_APP_STATE: '_RESET_APP_STATE',
  SET_USER: 'SET_USER',
  VENDOR_APPOINTMENTS_LOADED: 'VENDOR_APPOINTMENTS_LOADED',
  VENDOR_APPOINTMENTS_LOADING_STATUS: 'VENDOR_APPOINTMENTS_LOADING_STATUS',
  VENDOR_APPOINTMENT_UPDATE: 'VENDOR_APPOINTMENT_UPDATE',
}
